var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { PORTAL_ROUTE_PREFIX } from '../../constants/values';
import Groups from './groups';
import GroupsMembersListContainer from '../GroupsMembers/groups_members_list_container';
export var GroupsPageContainer = function (props) { return (React.createElement(Switch, null,
    React.createElement(Route, { exact: true, path: PORTAL_ROUTE_PREFIX + "/admin/:teamAccountId/groups", render: function () { return React.createElement(Groups, { teamAccountId: props.match.params.teamAccountId }); } }),
    React.createElement(Route, { path: PORTAL_ROUTE_PREFIX + "/admin/:teamAccountId/groups/:groupId/:page?", render: function (routeProps) { return React.createElement(GroupsMembersListContainer, __assign({}, routeProps)); } }))); };
export default withRouter(GroupsPageContainer);
